export function downloadUrl(url: string) {
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.target = '_blank';
  a.download = 'Statement.pdf';
  document.body.appendChild(a);
  a.click();
}
